import React, { useMemo } from "react";

import "./styles.scss";
import CourseItem from "common/components/CourseItem";
import { GameType } from "types/game";
import HandPlayCourseIcon from "assets/images/CardCourse-icon.svg";
import TricksCourseIcon from "assets/icons/courses/tricksMobile.svg";
import DefLeadCourseIcon from "assets/icons/def_lead_courses_exercises.png";
import MiniBridgeIcon from "assets/images/miniBridgeIcon.svg";
import PracticeByTechniqueTab from "../PracticeByTechniqueTab";
import { useLocation } from "react-router-dom";
import DeffeseIcon from "assets/images/deffenseIcon.svg";
import { BiddingEnum } from "enums/enums";

interface Props {
  data?: any[];
  onPressItem?: (val: any, type: "interactive-bidding" | "bidding") => void;
  searchData?: any[];
  isFirstTab?: boolean;
  searchText?: string;
  type: GameType | "practice";
}

const RenderCoursesMobile = ({
  data,
  onPressItem,
  searchData,
  isFirstTab,
  searchText,
  type
}: Props) => {
  const location = useLocation();

  const imgCourse = useMemo(() => {
    switch (type) {
      case "hand_play":
        return HandPlayCourseIcon;
      case "tricks":
        return TricksCourseIcon;
      case "deffense":
        return DeffeseIcon;
      case "def_lead":
        return DefLeadCourseIcon;
      case "mini_bridge":
        return MiniBridgeIcon;
      default:
        return HandPlayCourseIcon;
    }
  }, [type]);

  const iconClassName = type === "mini_bridge" ? "minibridge-course-icon" : undefined;

  return (
    <div
      className={`PracticeByCourses-main-mobile ${
        type === "practice" ? "practiceByCourses-main-techinque" : "PracticeByCourses-main"
      } ${isFirstTab ? "FirstTab-main" : ""}`}>
      <div className="PracticeByCoursesTab-ul">
        {type === "practice" && (
          <PracticeByTechniqueTab
            search={searchText}
            type={location.pathname === "/by_hand_play_exercise" ? "hand_play" : "deffense"}
          />
        )}
        {type !== "practice" && (
          <>
            {searchData && searchText && (
              <div
                className={`practiceByCoursesTab-ul-container practiceByCoursesTab-ul-container-search ${
                  type === "tricks" || type === "def_lead" ? "practiceByCoursesTab-def_lead" : ""
                }`}>
                {searchData.map((val, index) => {
                  if (val === null) {
                    return null;
                  }

                  const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;

                  return (
                    <CourseItem
                      key={`${val.Data?.Id_Course}_${index}_${val?.Data?.CourseKey}`}
                      onPressItem={
                        !isDisabled && onPressItem
                          ? () =>
                              onPressItem(
                                val,
                                val?.IsInteractive
                                  ? BiddingEnum.INTERACTIVE_BIDDING
                                  : BiddingEnum.BIDDING
                              )
                          : undefined
                      }
                      isDisabled={isDisabled}
                      isInteractive={val?.IsInteractive}
                      title={val.Name}
                      img={imgCourse}
                      isBidPlay={!!val?.BidPlay}
                      iconClassName={iconClassName}
                    />
                  );
                })}
              </div>
            )}
            {searchText?.length === 0 && (
              <div
                className={`practiceByCoursesTab-ul-container ${
                  type === "tricks" || type === "def_lead" ? "practiceByCoursesTab-def_lead" : ""
                }`}
                style={{
                  justifyContent: "space-between"
                }}>
                {data?.map((val, indexItemCourse: number) => {
                  if (val === null) {
                    return (
                      <div
                        key={indexItemCourse}
                        className="list-item-courses-bidding"
                        style={{ opacity: 0 }}></div>
                    );
                  }
                  if (typeof val?.IsDisplay === "boolean" && !val?.IsDisplay) {
                    return null;
                  }
                  const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;

                  return (
                    <CourseItem
                      key={`${val.Id}${val.CourseId}${val?.ParentSubject}${indexItemCourse}`}
                      onPressItem={
                        !isDisabled && onPressItem
                          ? () =>
                              onPressItem(
                                val,
                                val?.IsInteractive
                                  ? BiddingEnum.INTERACTIVE_BIDDING
                                  : BiddingEnum.BIDDING
                              )
                          : undefined
                      }
                      isInteractive={val?.IsInteractive}
                      isDisabled={isDisabled}
                      title={val.Name}
                      img={imgCourse}
                      isBidPlay={!!val?.BidPlay}
                      iconClassName={iconClassName}
                    />
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default RenderCoursesMobile;
